import {alpha} from '@material-ui/core/styles';

import {dialogScrollbar} from 'src/styles/scrollbar';

export const grid = theme => ({
  MuiDataGrid: {
    root: {
      ...dialogScrollbar(theme),
      backgroundColor: theme.palette.colors.blue[700],
      border: `1px solid ${theme.palette.colors.blue[500]}`,
      borderRadius: 8,
      padding: theme.spacing(3),

      '& .MuiDataGrid-window': {
        '&::-webkit-scrollbar': {
          width: 6,
          height: 6,

          [theme.breakpoints.down('sm')]: {width: 4}
        },
        '&::-webkit-scrollbar-track': {
          // backgroundColor: 'transparent',
          borderRadius: 12,
          // opacity: 0.1,
          backgroundColor: alpha('#404C66', 0.1)
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#404C66',
          borderRadius: 12
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: alpha('#404C66', 0.8)
        }
      },

      '& .MuiDataGrid-footerContainer': {
        minHeight: 36
      },

      '& .MuiDataGrid-cell': {
        borderBottom: `1px solid ${theme.palette.colors.blue[500]}`
      },

      '& .MuiDataGrid-columnsContainer': {
        borderBottom: `1px solid ${theme.palette.colors.blue[500]}`
      },

      '& .MuiDataGrid-columnHeaderWrapper': {
        paddingTop: theme.spacing(0.5)
      },

      '& .MuiDataGrid-columnSeparator': {
        display: 'none'
      },

      '& .MuiDataGrid-columnHeader:first-child': {
        paddingLeft: 0
      },

      '& .MuiDataGrid-columnHeaderTitleContainer': {
        padding: 0,

        '& .MuiDataGrid-columnHeaderTitle': {
          fontWeight: 600,
          fontSize: 16
        }
      },

      '& .MuiDataGrid-row .MuiDataGrid-cell:first-child': {
        paddingLeft: 0
      },

      '& .MuiDataGrid-overlay': {
        backgroundColor: 'transparent',

        '& svg': {
          color: theme.palette.colors.blue[200]
        }
      },

      '& .MuiDataGrid-columnHeader': {
        '&:last-child > div > div > div': {
          marginLeft: 'auto'
        }
      }
    },

    columnHeader: {
      '&:last-child > div > div > div': {
        textAlign: 'end'
      }
    },

    columnHeaderTitleContainer: {
      padding: 0
    },

    cell: {
      borderBottom: `1px solid ${theme.palette.colors.blue[500]}`
    }
  },

  MuiTablePagination: {
    actions: {
      '& button': {
        padding: 4
      },
      '& button.Mui-disabled': {
        color: theme.palette.colors.blue[600]
      }
    },

    toolbar: {
      height: 36,
      minHeight: 36,
      marginBottom: theme.spacing(1)
    }
  }
});
